/**
 * @Description 全市分析
 */

import { FC } from 'react';

import styles from './index.module.less';
import BaseInfoModule from './components/BaseInfoModule';
import PopulationModule from './components/PopulationModule';
import GDPModel from './components/GDPModel';
import { Col, Row } from 'antd';

interface CitywideAnalyseProps {
  data: any;
  name: string;
  level?: 1 | 2 | 3; // 1 全国， 2 省视图， 3 市视图
}

const CitywideAnalyse: FC<CitywideAnalyseProps> = ({ data, name, level }) => {

  return (
    <div className={styles.container}>
      {/* 基本信息 */}
      <BaseInfoModule data={data} level={level}/>
      <Row gutter={[8, 8]}>
        <Col span={12}>
          {/* 人口变化 */}
          <PopulationModule data={data} name={name} />
        </Col>
        <Col span={12}>
          {/* GDP及增速情况 */}
          <GDPModel data={data} name={name} />
        </Col>
      </Row>
    </div>
  );
};

export default CitywideAnalyse;
